import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { mapMarker, envelopeOpen, volumeControlPhone, facebookSquare, twitterSquare, linkedinSquare } from 'react-icons-kit/fa'
import { Title, Description } from '../../components/title/index';
import PreviewIcon from '../../components/icon/index';
import Image from '../../components/image/index';
import logo from '../../assets/images/Logo.png';
import { arrowRightCircle } from 'react-icons-kit/feather/arrowRightCircle'
import './footer.scss';

function Footer() {
    return (
        <div className="footer-wrapper">
            <Container>
                <div className="footer-content-wrapper">
                    <Row>
                        <Col lg={4} md={4} sm={6}>
                            <div className="footer-logo-wrapper">
                                <Image Path={logo} Class="footer-logo" />
                                <Description
                                    Class="footer-dec"
                                    Name="A good mobile strategy provides aggressive revenues, reduce costs substantially, flexibilty for staff, improved functionality and increases transparency for users and management."
                                />
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={6}>
                            <div className="footer-contact-us">
                                <Title Class="footer-title" Name="Contact Us" />
                                <div className="footer-details-link">
                                    <ul>
                                        <li>
                                            <a href="https://goo.gl/maps/9XXrr5eeSaXsUZ5w7" target="_blank">
                                                <span>
                                                    <PreviewIcon icon={mapMarker} />
                                                </span>
                                                <Title
                                                    Class="footer-link"
                                                    Name="4 Longwalk, Stockley Park, Uxbridge UB11 1FE"
                                                />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="mailto:jamie@ngtts.co.uk">
                                                <span>
                                                    <PreviewIcon icon={envelopeOpen} />
                                                </span>
                                                <Title
                                                    Class="footer-link footer-email"
                                                    Name="jamie@ngtts.co.uk"
                                                />
                                            </a>
                                        </li>
                                        <li className="d-none">
                                            <a href="/">
                                                <span>
                                                    <PreviewIcon icon={volumeControlPhone} />
                                                </span>
                                                <Title Class="footer-link" Name="+1 123 - 564 - 7890" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        <Col xl={3} lg={4} xs={2} md={4} sm={6}>
                            <div className="footer-about-us">
                                <div className="footer-about-outer">
                                    <Title Class="footer-title" Name="About Us" />
                                    <div className="footer-details-link">
                                        <ul>
                                            <li>
                                                <a href="/">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="Home"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/who-we-are">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="Who We Are"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/what-we-do">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="What We Do"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/business-transformation">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="Business Transformation"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/products-and-services">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="Products & Services"
                                                    />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/#contact">
                                                    <PreviewIcon icon={arrowRightCircle} />
                                                    <Title
                                                        Class="footer-link footer-arrow"
                                                        Name="Contact"
                                                    />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>

    );
}

export default Footer;